import { cmcTheme, cmcDarkTheme, themeNoGlobalStyles } from './cmc';
import { ITheme } from './theme';
import { bendigoTheme, bendigoDarkTheme } from './bendigo';
import { stGeorgeTheme, stGeorgeDarkTheme } from './stGeorge';
import { rivkinTheme, rivkinDarkTheme } from './rivkin';
import { advantageTheme, advantageDarkTheme } from './advantage';
import { asbTheme, asbDarkTheme } from './asb';
import { eBrokingTheme, eBrokingDarkTheme } from './eBroking';
import { cmcAlphaTheme, cmcAlphaDarkTheme } from './cmcAlpha';
import { westpacTheme, westpacDarkTheme } from './westpac';
// DO NOT REMOVE LINE - THEME_IMPORT
import { THEMES, Theme } from '@cmctechnology/webinvest-constants';
import { cmcSingaporeDarkTheme, cmcSingaporeTheme } from './cmcSingapore';

export const NOGLOBALSTYLESTHEMES = {
  CmcNoGlobal: 'themeNoGlobalStyles'
} as const;

export type NoGlobalStylesTheme = (typeof NOGLOBALSTYLESTHEMES)[keyof typeof NOGLOBALSTYLESTHEMES];

// type DarkThemeName<K> = K extends Theme ? `${K}Dark` : K;
// const darkTheme = (theme: Theme): DarkThemeName<Theme> => `${theme}Dark`;

export const themes: Partial<Record<Theme | NoGlobalStylesTheme, ITheme>> = {
  [THEMES.Advantage]: advantageTheme,
  [THEMES.ASB]: asbTheme,
  [THEMES.Bendigo]: bendigoTheme,
  [THEMES.CMC]: cmcTheme,
  [THEMES.CMCAlpha]: cmcAlphaTheme, //TODO adjust alpha theme
  [THEMES.CMCSingapore]: cmcSingaporeTheme,
  [THEMES.eBroking]: eBrokingTheme,
  [THEMES.Rivkin]: rivkinTheme,
  [THEMES.StGeorge]: stGeorgeTheme,
  [THEMES.Westpac]: westpacTheme,
  // DO NOT REMOVE LINE - THEMES_COLLECTION
  [NOGLOBALSTYLESTHEMES.CmcNoGlobal]: themeNoGlobalStyles
};

export const darkThemes: Partial<Record<Theme | NoGlobalStylesTheme, ITheme>> = {
  [THEMES.Advantage]: advantageDarkTheme,
  [THEMES.ASB]: asbDarkTheme,
  [THEMES.Bendigo]: bendigoDarkTheme,
  [THEMES.CMC]: cmcDarkTheme,
  [THEMES.CMCAlpha]: cmcAlphaDarkTheme,
  [THEMES.CMCSingapore]: cmcSingaporeDarkTheme,
  [THEMES.eBroking]: eBrokingDarkTheme,
  [THEMES.Rivkin]: rivkinDarkTheme,
  [THEMES.StGeorge]: stGeorgeDarkTheme,
  [THEMES.Westpac]: westpacDarkTheme,
  // DO NOT REMOVE LINE - THEMES_DARK_COLLECTION
  [NOGLOBALSTYLESTHEMES.CmcNoGlobal]: themeNoGlobalStyles
};

export { cmcTheme, cmcDarkTheme } from './cmc';
export { cmcTheme as theme } from './cmc';
export { themeNoGlobalStyles } from './cmc';
export { bendigoTheme, bendigoDarkTheme } from './bendigo';
export { stGeorgeTheme, stGeorgeDarkTheme } from './stGeorge';
export { rivkinTheme, rivkinDarkTheme } from './rivkin';
export { advantageTheme, advantageDarkTheme } from './advantage';
export { asbTheme, asbDarkTheme } from './asb';
export { eBrokingTheme, eBrokingDarkTheme } from './eBroking';
export { cmcAlphaTheme, cmcAlphaDarkTheme } from './cmcAlpha';
export { cmcSingaporeTheme, cmcSingaporeDarkTheme } from './cmcSingapore';
export { westpacTheme, westpacDarkTheme } from './westpac';
// DO NOT REMOVE LINE - THEME_EXPORT
